import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import axios from "axios";
import { API_PATH } from "./const";
import Application from "../pages/Application";

const VisitorSideBar = (props) => {
  const [open, setOpen] = React.useState(false);
  const [open01, setOpen01] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const [open5, setOpen5] = React.useState(false);
  const [company, setCompany] = useState({});
  const [me, setMe] = useState([]);

  let history = useHistory();
  const handleClick = () => {
    setOpen(!open);
    setOpen2(false);
    setOpen3(false);
    setOpen5(false);
  };
  const handleClick01 = () => {
    setOpen01(!open01);
    setOpen2(false);
    setOpen(false);

    setOpen3(false);
    setOpen5(false);
  };
  const handleClick2 = () => {
    setOpen2(!open2);
    setOpen(false);
    setOpen01(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
  };
  const handleClick3 = () => {
    setOpen3(!open3);
    setOpen(false);
    setOpen2(false);
    setOpen4(false);
    setOpen5(false);
    setOpen01(false);
  };
  const handleClick4 = () => {
    setOpen4(!open4);
    setOpen(false);
    setOpen2(false);
    setOpen3(false);
    setOpen5(false);
    setOpen01(false);
  };
  const handleClick5 = () => {
    setOpen5(!open5);
    setOpen(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen01(false);
  };

  const getCompany = () => {
    if (localStorage.getItem("for_com")) {
      axios
        .get(API_PATH + "company/" + localStorage.getItem("for_com"), {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        })
        .then((res) => {
          setCompany(res.data);
          localStorage.setItem("name", res?.data?.name);
          localStorage.setItem("company_type", res?.data?.type);
          localStorage.setItem("description", res?.data?.description);
          localStorage.setItem("phone", res?.data?.phone);
          localStorage.setItem("email", res?.data?.email);
          localStorage.setItem("id", res?.data?.id);
          localStorage.setItem("owner_id", res?.data?.owner_id);
        });
    }
    axios
      .get(API_PATH + "user/me", {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then((res) => {
        setMe(res.data?.permission_actions);
      });
  };
  const logout = () => {
    history.push("/login");
    localStorage.clear();
  };
  useEffect(() => {
    getCompany();
  }, []);
  return (
    <div className="main-side-bar">
      <div className="my-side-fix">
        {window.location.pathname?.slice(0, 13) === "/global-admin" ? (
          <div className="top-logo"></div>
        ) : (
          <div className="top-logo">
            <Link to="/main/visitor-home">
              {company ? (
                <img
                  src={
                    company?.logo?.slice(0, 8) === "https://" ||
                    company?.logo?.slice(0, 7) === "http://"
                      ? company?.logo
                      : "https://" + company?.logo
                  }
                  alt="..."
                  className="logo-company"
                />
              ) : (
                <img
                  src="/img/visitorLogo.png"
                  className="logo-company"
                  alt="..."
                />
              )}
            </Link>
          </div>
        )}
        {window.location.pathname?.slice(0, 13) === "/global-admin" ? (
          <div className="menu-list">
            <div className="menu-list-item">
              <ListItemButton
                sx={{ pl: 2 }}
                className={
                  window.location.pathname.startsWith(
                    "/global-admin/admin-companies"
                  )
                    ? "link-item-style-active"
                    : ""
                }
              >
                <Link
                  to="/global-admin/admin-companies"
                  className="link-item-style "
                >
                  <img src="/icon/cpu.svg" alt="" />
                  <span>Kомпании</span>
                </Link>
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 2 }}
                className={
                  window.location.pathname.startsWith("/global-admin/services")
                    ? "link-item-style-active"
                    : ""
                }
              >
                <Link to="/global-admin/services" className="link-item-style ">
                  <img src="/icon/cpu.svg" alt="" />
                  <span>Услуги</span>
                </Link>
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 2 }}
                className={
                  window.location.pathname.startsWith("/global-admin/support")
                    ? "link-item-style-active"
                    : ""
                }
              >
                <Link to="/global-admin/support" className="link-item-style ">
                  <img src="/icon/cpu.svg" alt="" />
                  <span>Поддержка</span>
                </Link>
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 2 }}
                className={
                  window.location.pathname.startsWith(
                    "/global-admin/application"
                  )
                    ? "link-item-style-active"
                    : ""
                }
              >
                <Link
                  to="/global-admin/application"
                  className="link-item-style "
                >
                  <img src="/icon/cpu.svg" alt="" />
                  <span>Заяфки</span>
                </Link>
              </ListItemButton>
            </div>
            <div className="menu-list-bottom">
              <div className="left-img-center">
                <div className="d-flex align-items-center">
                  <Link to="/global-admin/companies" className="left-img">
                    {localStorage.getItem("image") === "null" ? (
                      <img src="/icon/profileUser.png" alt="" />
                    ) : (
                      <img src={localStorage.getItem("image")} alt="." />
                    )}
                  </Link>
                  <div className="center-content">
                    <h5 className="font-family-medium text-white">
                      {/*<Link   to="/main/hr-admin/employees/user-profile"> */}
                      {localStorage.getItem("first_name") === "null"
                        ? "User"
                        : localStorage.getItem("first_name") +
                          " " +
                          localStorage.getItem("last_name")?.slice(0, 1) +
                          "."}
                      {/*</Link>*/}
                    </h5>
                    {/*<h6>*/}
                    {/*    {*/}
                    {/*        localStorage.getItem("phone_user") === "null" ?*/}
                    {/*            ""*/}
                    {/*            :*/}
                    {/*            localStorage.getItem("phone_user")*/}
                    {/*    }*/}
                    {/*</h6>*/}
                  </div>
                </div>
                <button onClick={logout}>
                  <img src="/icon/logout2.svg" alt="logout" />
                </button>
              </div>
              {/*<div className="right-dot">*/}
              {/*    <button type="submit"><img src="/icon/verdot.svg" alt="..."/></button>*/}
              {/*</div>*/}
            </div>
          </div>
        ) : (
          <div className="menu-list">
            <div className="menu-list-item">
              {me?.filter((item) => item === "view_branch").length > 0 ? (
                <ListItemButton
                  sx={{ pl: 2 }}
                  className={
                    window.location.pathname.startsWith(
                      "/main/hierarchy/company"
                    )
                      ? "link-item-style-active"
                      : ""
                  }
                >
                  <Link
                    to="/main/hierarchy/company"
                    className="link-item-style "
                  >
                    <img src="/icon/Hierarchy.svg" alt="" />
                    <span>Структура компании</span>
                  </Link>
                </ListItemButton>
              ) : (
                ""
              )}

              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "background.paper",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                {/*company?.services?.filter(item => item === "visitor_analytics_by_smart_camera")?.length > 0 ?*/}

                {company?.services?.filter(
                  (item) => item === "visitor_analytics_by_smart_camera"
                )?.length > 0 ||
                company?.services?.filter(
                  (item) => item === "visitor_analytics_by_module"
                )?.length > 0 ? (
                  me?.filter((item) => item === "view_visitor_analytics")
                    .length > 0 ? (
                    <ListItemButton onClick={handleClick}>
                      <div className="link-item-style ">
                        <img src="/icon/analys2.svg" alt="" />
                        <span>Аналитика посетителей</span>
                      </div>
                      {open ? (
                        <img
                          src="/icon/arrowup.png"
                          className="arrow-up-down-size"
                        />
                      ) : (
                        <img
                          src="/icon/arrowdown.png"
                          className="arrow-up-down-size"
                        />
                      )}
                    </ListItemButton>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {company?.services?.filter(
                      (item) => item === "visitor_analytics_by_smart_camera"
                    )?.length > 0 ? (
                      me?.filter((item) => item === "view_analytics").length >
                      0 ? (
                        <ListItemButton
                          sx={{ pl: 2 }}
                          className={
                            window.location.pathname.startsWith(
                              "/main/visitor-home"
                            )
                              ? "link-item-style-active"
                              : ""
                          }
                        >
                          <Link
                            to="/main/visitor-home"
                            className="link-item-style "
                          >
                            <img
                              src="/icon/datareport2.png"
                              style={{ width: "24px" }}
                              alt=""
                            />
                            <span>Аналитика</span>
                          </Link>
                        </ListItemButton>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {company?.services?.filter(
                      (item) => item === "visitor_analytics_by_smart_camera"
                    )?.length > 0 ? (
                      me?.filter((item) => item === "view_comparison_by_branch")
                        .length > 0 ? (
                        <ListItemButton
                          sx={{ pl: 2 }}
                          className={
                            window.location.pathname.startsWith(
                              "/main/visitor-comparasion"
                            )
                              ? "link-item-style-active"
                              : ""
                          }
                        >
                          <Link
                            to="/main/visitor-comparasion"
                            className="link-item-style  "
                          >
                            <img src="/icon/donutchart2.png" alt="" />
                            <span>Сравнение по филиалом</span>
                          </Link>
                        </ListItemButton>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {company?.services?.filter(
                      (item) => item === "visitor_analytics_by_smart_camera"
                    )?.length > 0 ? (
                      me?.filter((item) => item === "view_comparison_by_branch")
                        .length > 0 ? (
                        <ListItemButton
                          sx={{ pl: 2 }}
                          className={
                            window.location.pathname.startsWith(
                              "/main/visitor-date-comparasion"
                            )
                              ? "link-item-style-active"
                              : ""
                          }
                        >
                          <Link
                            to="/main/visitor-date-comparasion"
                            className="link-item-style  "
                          >
                            <img src="/icon/donutchart2.png" alt="" />
                            <span>Сравнение по дата</span>
                          </Link>
                        </ListItemButton>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {company?.services?.filter(
                      (item) => item === "visitor_analytics_by_module"
                    )?.length > 0 ? (
                      me?.filter((item) => item === "view_service_time")
                        .length > 0 ? (
                        <ListItemButton
                          sx={{ pl: 2 }}
                          className={
                            window.location.pathname.startsWith(
                              "/main/service-time"
                            )
                              ? "link-item-style-active"
                              : ""
                          }
                        >
                          <Link
                            to="/main/service-time"
                            className="link-item-style  "
                          >
                            <img src="/icon/roi_visitor2.svg" alt="" />
                            <span>Время обслуживания</span>
                          </Link>
                        </ListItemButton>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </List>
                </Collapse>
              </List>
              {/*<List*/}
              {/*    sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}*/}
              {/*    component="nav"*/}
              {/*    aria-labelledby="nested-list-subheader"*/}
              {/*>*/}
              {/*    <ListItemButton onClick={handleClick01}>*/}
              {/*        <div className="link-item-style ">*/}
              {/*            <img src="/icon/Users_Group2.svg" alt=""/>*/}
              {/*            <span>WorkSpace</span>*/}
              {/*        </div>*/}
              {/*        {open01 ? <img src="/icon/arrowup.png" className="arrow-up-down-size"/> :*/}
              {/*            <img src="/icon/arrowdown.png" className="arrow-up-down-size"/>}*/}
              {/*    </ListItemButton>*/}
              {/*    <Collapse in={open01} timeout="auto" unmountOnExit>*/}
              {/*        <List component="div" disablePadding>*/}
              {/*      */}

              {/*        </List>*/}
              {/*    </Collapse>*/}
              {/*</List>*/}
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "background.paper",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <ListItemButton onClick={handleClick3}>
                  <div className="link-item-style ">
                    <img src="/icon/Icon102.svg" alt="" />
                    <span>HR</span>
                  </div>
                  {open3 ? (
                    <img
                      src="/icon/arrowup.png"
                      className="arrow-up-down-size"
                    />
                  ) : (
                    <img
                      src="/icon/arrowdown.png"
                      className="arrow-up-down-size"
                    />
                  )}
                </ListItemButton>
                <Collapse in={open3} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {company?.services?.filter(
                      (item) => item === "hr_analytics_by_smart_camera"
                    )?.length > 0 ? (
                      me?.filter((item) => item === "view_hr").length > 0 ? (
                        <ListItemButton
                          sx={{ pl: 2 }}
                          className={
                            window.location.pathname.startsWith(
                              "/main/hr-admin/home-page-hr"
                            )
                              ? "link-item-style-active"
                              : ""
                          }
                        >
                          <Link
                            to="/main/hr-admin/home-page-hr"
                            className="link-item-style "
                          >
                            <img src="/icon/Icon121.svg" alt="" />
                            <span>HR аналитика</span>
                          </Link>
                        </ListItemButton>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {/*{*/}
                    {/*    company?.services?.filter(item => item === "hr_analytics_by_module")?.length > 0 || company?.services?.filter(item => item === "hr_analytics_by_smart_camera")?.length > 0 ?*/}
                    {/*        <ListItemButton sx={{pl: 2}}*/}
                    {/*                        className={window.location.pathname.startsWith("/main/working-time") ? "link-item-style-active" : ""}>*/}
                    {/*            <Link to="/main/working-time" className="link-item-style ">*/}
                    {/*                <img src="/icon/roi_employee2.svg" alt=""/>*/}
                    {/*                <span>ROI Employee</span>*/}
                    {/*            </Link>*/}
                    {/*        </ListItemButton>*/}
                    {/*        :*/}
                    {/*        ""*/}
                    {/*}*/}
                    {me?.filter((item) => item === "view_department").length >
                    0 ? (
                      <ListItemButton
                        sx={{ pl: 2 }}
                        className={
                          window.location.pathname.startsWith(
                            "/main/hr-admin/departments"
                          )
                            ? "link-item-style-active"
                            : ""
                        }
                      >
                        <Link
                          to="/main/hr-admin/departments"
                          className="link-item-style "
                        >
                          <img src="/icon/Icon102.svg" alt="" />
                          <span>Отделы</span>
                        </Link>
                      </ListItemButton>
                    ) : (
                      ""
                    )}
                    {me?.filter((item) => item === "view_employee").length >
                    0 ? (
                      <ListItemButton
                        sx={{ pl: 2 }}
                        className={
                          window.location.pathname.startsWith(
                            "/main/hr-admin/employees"
                          )
                            ? "link-item-style-active"
                            : ""
                        }
                      >
                        <Link
                          to="/main/hr-admin/employees"
                          className="link-item-style "
                        >
                          <img src="/icon/roi_visitor2.svg" alt="" />
                          <span>Cотрудники</span>
                        </Link>
                      </ListItemButton>
                    ) : (
                      ""
                    )}
                    {me?.filter((item) => item === "view_employeeworkschedule")
                      .length > 0 ? (
                      <ListItemButton
                        sx={{ pl: 2 }}
                        className={
                          window.location.pathname.startsWith(
                            "/main/hr-admin/modes"
                          )
                            ? "link-item-style-active"
                            : ""
                        }
                      >
                        <Link
                          to="/main/hr-admin/modes"
                          className="link-item-style "
                        >
                          <img src="/icon/Icon1122.svg" alt="" />
                          <span>Режимы</span>
                        </Link>
                      </ListItemButton>
                    ) : (
                      ""
                    )}

                    {/*<ListItemButton sx={{pl: 2}} className={window.location.pathname.startsWith === "/main/hr-admin/audit" ? "link-item-style-active" : ""}>*/}
                    {/*    <Link to="/main/hr-admin/audit" className="link-item-style ">*/}
                    {/*        <img src="/icon/Icon6.svg" alt=""/>*/}
                    {/*        <span>Аудит</span>*/}
                    {/*    </Link>*/}
                    {/*</ListItemButton>*/}
                    {/*<ListItemButton sx={{ pl: 2 }}>*/}
                    {/*    <Link to="/main/hr-admin/logging" className="link-item-style ">*/}
                    {/*        <img src="/icon/Icon6.svg" alt=""/>*/}
                    {/*        <span>Логирование</span>*/}
                    {/*    </Link>*/}
                    {/*</ListItemButton>*/}

                    {/*<ListItemButton sx={{ pl: 2 }}>*/}
                    {/*    <Link to="/main/hr-admin/notification" className="link-item-style ">*/}
                    {/*        <img src="/icon/Icon8.svg" alt=""/>*/}
                    {/*        <span>Уведомления</span>*/}
                    {/*    </Link>*/}
                    {/*</ListItemButton>*/}
                  </List>
                </Collapse>
              </List>
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "background.paper",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <ListItemButton onClick={handleClick4}>
                  <div className="link-item-style ">
                    <img src="/icon/Live2.svg" alt="" />
                    <span>Live</span>
                  </div>
                  {open4 ? (
                    <img
                      src="/icon/arrowup.png"
                      className="arrow-up-down-size"
                    />
                  ) : (
                    <img
                      src="/icon/arrowdown.png"
                      className="arrow-up-down-size"
                    />
                  )}
                </ListItemButton>
                <Collapse in={open4} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {company?.services?.filter(
                      (item) => item === "visitor_analytics_by_smart_camera"
                    )?.length > 0 ? (
                      me?.filter((item) => item === "view_live").length > 0 ? (
                        <ListItemButton
                          sx={{ pl: 2 }}
                          className={
                            window.location.pathname.startsWith("/main/live")
                              ? "link-item-style-active"
                              : ""
                          }
                        >
                          <Link to="/main/live" className="link-item-style ">
                            <img src="/icon/Live2.svg" alt="" />
                            <span>Live</span>
                          </Link>
                        </ListItemButton>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </List>
                  {/*{*/}

                  {/*    company?.services?.filter(item => item === "hr_analytics_by_module")?.length > 0 ?*/}
                  {/*        <List component="div" disablePadding>*/}
                  {/*            <ListItemButton sx={{pl: 2}}*/}
                  {/*                            className={window.location.pathname.startsWith("/main/roi-employee-live") ? "link-item-style-active" : ""}>*/}
                  {/*                <Link to="/main/roi-employee-live" className="link-item-style ">*/}
                  {/*                    <img src="/icon/roi_employee2.svg" alt=""/>*/}
                  {/*                    <span>ROI Employee</span>*/}
                  {/*                </Link>*/}
                  {/*            </ListItemButton>*/}
                  {/*        </List>*/}
                  {/*        :*/}
                  {/*        ""*/}
                  {/*}*/}

                  <List component="div" disablePadding>
                    {company?.services?.filter(
                      (item) => item === "visitor_analytics_by_module"
                    )?.length > 0 ? (
                      <ListItemButton
                        sx={{ pl: 2 }}
                        className={
                          window.location.pathname.startsWith(
                            "/main/roi-visitor-live"
                          )
                            ? "link-item-style-active"
                            : ""
                        }
                      >
                        <Link
                          to="/main/roi-visitor-live"
                          className="link-item-style "
                        >
                          <img src="/icon/roi_visitor2.svg" alt="" />
                          <span>ROI Visitor</span>
                        </Link>
                      </ListItemButton>
                    ) : (
                      ""
                    )}
                  </List>
                </Collapse>
              </List>
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "background.paper",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <ListItemButton onClick={handleClick5}>
                  <div className="link-item-style ">
                    <img src="/icon/settings2.svg" alt="" />
                    <span>Настройки</span>
                  </div>
                  {open5 ? (
                    <img
                      src="/icon/arrowup.png"
                      className="arrow-up-down-size"
                    />
                  ) : (
                    <img
                      src="/icon/arrowdown.png"
                      className="arrow-up-down-size"
                    />
                  )}
                </ListItemButton>
                <Collapse in={open5} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton
                      sx={{ pl: 2 }}
                      className={
                        window.location.pathname.startsWith(
                          "/main/hr-admin/users"
                        )
                          ? "link-item-style-active"
                          : ""
                      }
                    >
                      <Link
                        to="/main/hr-admin/users"
                        className="link-item-style "
                      >
                        <img src="/icon/Icon72.svg" alt="" />
                        <span>Пользователи</span>
                      </Link>
                    </ListItemButton>
                    {/*<ListItemButton sx={{pl: 2}}*/}
                    {/*                className={window.location.pathname.startsWith("/main/hr-admin/branches") ? "link-item-style-active" : ""}>*/}
                    {/*    <Link to="/main/hr-admin/branches" className="link-item-style ">*/}
                    {/*        <img src="/icon/Icon92.svg" alt=""/>*/}
                    {/*        <span>Филиалы</span>*/}
                    {/*    </Link>*/}
                    {/*</ListItemButton>*/}

                    {company?.services?.filter(
                      (item) => item === "visitor_analytics_by_module"
                    )?.length > 0 ? (
                      <ListItemButton
                        sx={{ pl: 2 }}
                        className={
                          window.location.pathname.startsWith("/main/building")
                            ? "link-item-style-active"
                            : ""
                        }
                      >
                        <Link to="/main/building" className="link-item-style  ">
                          <img src="/icon/inf.svg" alt="" />
                          <span>Инфраструктура</span>
                        </Link>
                      </ListItemButton>
                    ) : (
                      ""
                    )}

                    {company?.services?.filter(
                      (item) => item === "visitor_analytics_by_smart_camera"
                    )?.length > 0 ? (
                      me?.filter((item) => item === "view_smart_camera")
                        .length > 0 ? (
                        <ListItemButton
                          sx={{ pl: 2 }}
                          className={
                            window.location.pathname.startsWith(
                              "/main/smart-camera"
                            )
                              ? "link-item-style-active"
                              : ""
                          }
                        >
                          <Link
                            to="/main/smart-camera"
                            className="link-item-style  "
                          >
                            <img src="/icon/camera22.svg" alt="" />
                            <span>Smart Camera</span>
                          </Link>
                        </ListItemButton>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {me?.filter((item) => item === "view_role").length > 0 ? (
                      <ListItemButton
                        sx={{ pl: 2 }}
                        className={
                          window.location.pathname.startsWith("/main/roles")
                            ? "link-item-style-active"
                            : ""
                        }
                      >
                        <Link to="/main/roles" className="link-item-style  ">
                          <img src="/icon/settings2.svg" alt="" />
                          <span>Roles</span>
                        </Link>
                      </ListItemButton>
                    ) : (
                      ""
                    )}
                    {company?.services?.filter(
                      (item) => item === "visitor_analytics_by_module"
                    )?.length > 0 ? (
                      <ListItemButton
                        sx={{ pl: 2 }}
                        className={
                          window.location.pathname.startsWith(
                            "/main/roi-employee"
                          )
                            ? "link-item-style-active"
                            : ""
                        }
                      >
                        <Link
                          to="/main/roi-employee"
                          className="link-item-style "
                        >
                          <img src="/icon/roi_employee2.svg" alt="" />
                          <span>ROI</span>
                        </Link>
                      </ListItemButton>
                    ) : (
                      ""
                    )}

                    {company?.services?.filter(
                      (item) => item === "visitor_analytics_by_module"
                    )?.length > 0 ? (
                      <ListItemButton
                        sx={{ pl: 2 }}
                        className={
                          window.location.pathname.startsWith(
                            "/main/my-modules"
                          )
                            ? "link-item-style-active"
                            : ""
                        }
                      >
                        <Link
                          to="/main/my-modules"
                          className="link-item-style  "
                        >
                          <img src="/icon/server2.svg" alt="" />
                          <span>Servers</span>
                        </Link>
                      </ListItemButton>
                    ) : (
                      ""
                    )}

                    {/*<ListItemButton sx={{pl: 2}}*/}
                    {/*                className={window.location.pathname.startsWith("/main/services") ? "link-item-style-active" : ""}>*/}
                    {/*    <Link to="/main/services" className="link-item-style  ">*/}
                    {/*        <img src="/icon/roi_employee2.svg" alt=""/>*/}
                    {/*        <span>Services</span>*/}
                    {/*    </Link>*/}
                    {/*</ListItemButton>*/}
                    {/*<ListItemButton sx={{pl: 2}}*/}
                    {/*                className={window.location.pathname.startsWith("/main/deployments") ? "link-item-style-active" : ""}>*/}
                    {/*    <Link to="/main/deployments" className="link-item-style     ">*/}
                    {/*        <img src="/icon/deployment2.svg" alt=""/>*/}
                    {/*        <span>Deployment</span>*/}
                    {/*    </Link>*/}
                    {/*</ListItemButton>*/}
                  </List>
                </Collapse>
                <ListItemButton
                  sx={{ pl: 2 }}
                  className={
                    window.location.pathname.startsWith(
                      "/main/camera-list-config"
                    )
                      ? "link-item-style-active"
                      : ""
                  }
                >
                  <Link
                    to="/main/camera-list-config"
                    className="link-item-style     "
                  >
                    <img src="/icon/settings2.svg" alt="" />
                    <span>Конфигурация камеры</span>
                  </Link>
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 2 }}
                  className={
                    window.location.pathname.startsWith("/main/support")
                      ? "link-item-style-active"
                      : ""
                  }
                >
                  <Link to="/main/support" className="link-item-style     ">
                    <img src="/icon/support.svg" alt="" />
                    <span>Поддержка</span>
                  </Link>
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 2 }}
                  className={
                    window.location.pathname.startsWith("/main/application")
                      ? "link-item-style-active"
                      : ""
                  }
                >
                  <Link to="/main/application" className="link-item-style">
                    <img src="/icon/roi_employee2.svg" alt="" />
                    <span>Продукты</span>
                  </Link>
                </ListItemButton>
              </List>
            </div>
            <div className="menu-list-bottom">
              <div className="left-img-center">
                <div className="d-flex align-items-center">
                  {/*<Link to="/main/hr-admin/employees/user-profile" className="left-img">*/}
                  {localStorage.getItem("image") === "null" ? (
                    <img
                      src={localStorage.getItem("image")}
                      alt=""
                      width="50"
                    />
                  ) : (
                    <img src="/icon/profileUser.png" alt="" />
                  )}
                  {/*</Link>*/}
                  <div className="center-content">
                    <h5 className="font-family-medium text-white">
                      {/*<Link    to="/main/hr-admin/employees/user-profile"> */}
                      {localStorage.getItem("first_name") === "null"
                        ? "User"
                        : localStorage.getItem("first_name") +
                          " " +
                          localStorage.getItem("last_name")?.slice(0, 1) +
                          "."}
                      {/*</Link>*/}
                    </h5>
                    {/*<h6>*/}
                    {/*    {*/}
                    {/*        localStorage.getItem("phone_user") === "null" ?*/}
                    {/*            ""*/}
                    {/*            :*/}
                    {/*            localStorage.getItem("phone_user")*/}
                    {/*    }*/}
                    {/*</h6>*/}
                  </div>
                </div>
                <button onClick={logout}>
                  <img src="/icon/logout2.svg" alt="logout" />
                </button>
              </div>
              {/*<div className="right-dot">*/}
              {/*    <button type="submit"><img src="/icon/verdot.svg" alt="..."/></button>*/}
              {/*</div>*/}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VisitorSideBar;
